import { Provider } from '@angular/core';
import { CommonContentService } from './common-content.service';
import { LoginContentService } from './login-content.service';
import { FooterContentService } from './footer-content.service';
import { HeaderContentService } from './header-content.service';
import { FormValidatorService } from './form-validator.service';
import { NewsFeedContentService } from './news-feed-content.service';
import { SummaryContentService } from './summary-content.service';
import { ContactusService } from './contactus.service';
import { BoundPolicyService } from './bound-policy.service';
import { StepsContentService } from './steps-content.service';
import { ForgotPasswordService } from './forgot-password.service';
import { ResetPasswordService } from './reset-password.service';
import { ScriptLoaderService } from './script-loader/js-script-loader.service';
import { UpdatePasswordContentService } from './update-password-content.service';
// services
export * from './common-content.service';
export * from './dashboard-content.service';
export * from './login-content.service';
export * from './footer-content.service';
export * from './header-content.service';
export * from './request-access-content.service';
export * from './agency-request-content.service';
export * from './kpi-content.service';
export * from './form-validator.service';
export * from './news-feed-content.service';
export * from './summary-content.service';
export * from './contactus.service';
export * from './bound-policy.service';
export * from './steps-content.service';
export * from './forgot-password.service';
export * from './reset-password.service';
export * from './def/news-feed';
export * from './update-phone-content.service';
export * from './update-email-content.service';
export * from './update-password-content.service';

export const ContentServiceProviders: Provider[] = [
  CommonContentService,
  LoginContentService,
  FooterContentService,
  HeaderContentService,
  FormValidatorService,
  NewsFeedContentService,
  SummaryContentService,
  ContactusService,
  BoundPolicyService,
  StepsContentService,
  ForgotPasswordService,
  ResetPasswordService,
  ScriptLoaderService,
  UpdatePasswordContentService
];
